import Bell from '@/shared/ui/icons/Bell.svg';
import Favorites from '@/shared/ui/icons/Favorites.svg';
import Gear from '@/shared/ui/icons/Gear.svg';
import Headphone from '@/shared/ui/icons/Headphone.svg';
import Home from '@/shared/ui/icons/Home.svg';
import List from '@/shared/ui/icons/List.svg';
import Peoples from '@/shared/ui/icons/Peoples.svg';
import Portfolio from '@/shared/ui/icons/Portfolio.svg';
import Profile from '@/shared/ui/icons/Profile.svg';
import Projects from '@/shared/ui/icons/Projects.svg';
import Star from '@/shared/ui/icons/Star.svg';

import { TRole } from '@/shared/types/role';

import { ACTOR_ROUTES, DIRECTOR_ROUTES, ROUTES } from '@/shared/constants';

import { INavItem } from '../model/types';

const actorNavItems: INavItem[] = [
  {
    Icon: Home,
    path: '/',
    isFillIcon: true,
    label: 'Главная'
  },
  {
    Icon: Projects,
    path: ACTOR_ROUTES.events.index.route,
    activePathPrefixes: [
      ACTOR_ROUTES.events.index.route,
      `${ACTOR_ROUTES.events.index.route}/projects`
    ],
    label: 'Проекты'
  },
  {
    Icon: Portfolio,
    path: ACTOR_ROUTES.events.companies.index,
    activePathPrefixes: [ACTOR_ROUTES.events.companies.index],
    label: 'Кинокомпании'
  },

  {
    Icon: Profile,
    path: ACTOR_ROUTES.profile.index.route,
    label: 'Мое портфолио'
  },
  {
    Icon: List,
    path: ACTOR_ROUTES.responses.index,
    label: 'Мои отклики'
  },
  {
    Icon: Peoples,
    path: ACTOR_ROUTES.actor_cards.index,
    isFillIcon: true,
    label: 'Визитки'
  },
  {
    Icon: Star,
    path: ROUTES.favorites,
    label: 'Избранное'
  },
  {
    Icon: Bell,
    path: ROUTES.notifications,
    label: 'Уведомления'
  },
  {
    Icon: Gear,
    path: ROUTES.settings,
    label: 'Настройки'
  },
  {
    Icon: Headphone,
    path: ROUTES.support,
    label: 'Поддержка'
  }
];

const directorNavItems: INavItem[] = [
  {
    Icon: Home,
    path: '/',
    isFillIcon: true,
    label: 'Главная'
  },
  {
    Icon: Portfolio,
    path: DIRECTOR_ROUTES.actors.index.route,
    label: 'Портфолио актёров'
  },
  {
    Icon: Peoples,
    path: DIRECTOR_ROUTES.actor_cards.index,
    isFillIcon: true,
    label: 'Реестр актёров'
  },
  {
    Icon: List,
    path: DIRECTOR_ROUTES.responses.index,
    label: 'Отклики актёров'
  },
  {
    Icon: Projects,
    path: DIRECTOR_ROUTES.projects.index,
    label: 'Проекты'
  },
  {
    Icon: Profile,
    path: DIRECTOR_ROUTES.profile.index,
    label: 'Мой профиль'
  },
  {
    Icon: Favorites,
    path: ROUTES.favorites,
    label: 'Избранное'
  },
  {
    Icon: Bell,
    path: ROUTES.notifications,
    label: 'Уведомления'
  },
  {
    Icon: Gear,
    path: ROUTES.settings,
    label: 'Настройки'
  },
  {
    Icon: Headphone,
    path: ROUTES.support,
    label: 'Поддержка'
  }
];

const navItems: Record<TRole, INavItem[]> = {
  actor: actorNavItems,
  director: directorNavItems
};

/**
 * Получаем список элементов сайдбара
 * @param role - роль пользователя
 */
export const getNavItems = (role: TRole): INavItem[] => navItems[role];
